import React, { useMemo } from 'react';
import { formatCurrency } from '../lib/capacityPlanningFormatters';

const RevenueOpportunityPanel = ({ items = [] }) => {
  const ranked = useMemo(
    () => [...items].sort((a, b) => Number(b?.estimatedRevenueOpportunity || 0) - Number(a?.estimatedRevenueOpportunity || 0)).slice(0, 6),
    [items],
  );

  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/80 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Peluang Revenue</h3>
      <div className="mt-3 space-y-2">
        {ranked.length === 0 ? <p className="text-xs text-slate-500">Belum ada data.</p> : ranked.map((row) => (
          <div key={row.candidateId} className="flex items-center justify-between rounded-md border border-slate-800 bg-slate-950/70 px-3 py-2 text-xs">
            <span className="text-slate-300">{row.areaName || row.scopeKey}</span>
            <span className="font-semibold text-emerald-300">{formatCurrency(row.estimatedRevenueOpportunity || 0)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RevenueOpportunityPanel;
